import axios from '../utils/axios';

export default function updateConfidentialStatus(adminId, jobId, data) {
    return axios.post('/admin/' + adminId + '/confidential-jobs/' + jobId, data)
}